import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import config from '../config';
import auth from '@bluedot-tech/vue-ui/es/utils/auth.js';

const wx = require('weixin-js-sdk');

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

// 授权
const handleAuth = auth({
	config: {
		...config.wechat,
		storagePrefix: config.storagePrefix
	}
});

// jssdk设置
const handleJssdk = () => {
	Vue.axios
		.get(config.jssdk.url, {
			params: {
				back_url: encodeURIComponent(window.location.href),
				appid: config.appid,
				js_api_list: config.jssdk.jsApiList.join(',')
			}
		})
		.then((res) => {
			wx.config({
				appId: res.data.appId,
				timestamp: res.data.timestamp,
				nonceStr: res.data.nonceStr,
				signature: res.data.signature,
				jsApiList: config.jssdk.jsApiList
			});
		});
};

// 路由守卫前置钩子
router.beforeEach((to, from, next) => {
	Vue.prototype.$loading.show();
	const { meta }: any = to;
	// 解决页面跳转后返回，然后在跳转监测路径错误问题
	const pathErrorTimeout = setTimeout(() => {
		clearTimeout(pathErrorTimeout);
		if (!meta.wechatAuth) {
			next();
			return;
		}
		handleAuth(to, from, next);
	}, 0);
});

// 路由守卫后置钩子
router.afterEach(() => {
	Vue.prototype.$loading.hide();
	handleJssdk();
});

export default router;
